var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#56AC14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9718 11.0004C21.7123 11.0082 21.4661 11.1167 21.2852 11.3029L14.0063 18.588L11.7192 16.2983C11.4687 16.0373 11.0968 15.9321 10.7468 16.0234C10.3969 16.1147 10.1236 16.3882 10.0323 16.7383C9.94109 17.0885 10.0462 17.4607 10.3071 17.7113L13.3002 20.7074C13.6902 21.0975 14.3224 21.0975 14.7124 20.7074L22.6974 12.7159C22.9927 12.4286 23.0815 11.9894 22.921 11.6099C22.7605 11.2303 22.3835 10.9883 21.9718 11.0004Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.841dd183182693c48d6a910ec7be2aa7.svg";
export { ForwardRef as ReactComponent };